(function () {
  'use strict';

  const VERSION = '2';
  const ROOT = '[data-tbc-post-add-offer]';
  const CONFIG = '[data-tbc-post-add-config]';
  const TABBABLE = 'button, select, input, textarea, a[href], [tabindex]';

  function eligibleVariants(config) {
    if (!config || config.template !== 'danielmogs2' || config.enabled !== true || config.requiresSellingPlan === true || !/^\d+$/.test(String(config.productId || '')) || Number(config.productId) <= 0) return [];
    return (Array.isArray(config.variants) ? config.variants : []).filter(function (variant) {
      const rule = variant.quantityRule || {};
      return /^\d+$/.test(String(variant.id || '')) && Number(variant.id) > 0 && variant.available === true && variant.eligible !== false && Number(rule.min || 1) <= 1 && Number(rule.increment || 1) === 1 && (rule.max === null || rule.max === undefined || Number(rule.max) >= 1);
    });
  }

  function createController(root, win) {
    const document = win.document;
    const state = { active: null, generation: 0, disposed: false, busy: false, accepted: false, uncertain: false, escapeGesture: false, retryable: true, variant: null, preview: false, locks: [], bodyOwned: false, previousFocus: null };
    function node(name) { return root.querySelector('[data-tbc-offer-' + name + ']'); }
    function configFromMarkup() {
      const script = root.querySelector(CONFIG);
      return script ? JSON.parse(script.textContent) : {};
    }
    function text(name, value) { const element = node(name); if (element) element.textContent = value || ''; }
    function hidden(name, value) { const element = node(name); if (element) element.hidden = value; }
    function labels() { return state.active && state.active.config.strings || {}; }
    function focusables() {
      return Array.from(root.querySelectorAll(TABBABLE)).filter(function (element) {
        return !element.disabled && !element.hidden && element.tabIndex !== -1 && !(element.closest && element.closest('[hidden]')) && (!element.getClientRects || element.getClientRects().length > 0);
      });
    }
    function focusFirst() {
      const first = node('close') || focusables()[0] || node('dialog');
      if (first && typeof first.focus === 'function') first.focus();
    }
    function ownInert(element) {
      state.locks.push({ element: element, inert: Boolean(element.inert), attribute: element.hasAttribute && element.hasAttribute('inert') });
      element.inert = true;
      if (element.setAttribute) element.setAttribute('inert', '');
    }
    function lockBackground() {
      state.previousFocus = document.activeElement;
      state.bodyOwned = !document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      if (typeof win.removeTrapFocus === 'function') win.removeTrapFocus();
      let branch = root;
      while (branch && branch !== document.body && branch.parentElement) {
        Array.from(branch.parentElement.children || []).forEach(function (sibling) {
          if (sibling !== branch && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) ownInert(sibling);
        });
        branch = branch.parentElement;
      }
    }
    function unlockBackground(restoreFocus) {
      state.locks.forEach(function (lock) {
        lock.element.inert = lock.inert;
        if (!lock.attribute && lock.element.removeAttribute) lock.element.removeAttribute('inert');
      });
      state.locks = [];
      const activeDrawer = document.querySelector && document.querySelector('cart-drawer.active, cart-drawer[data-tbc-opening="true"]');
      if (state.bodyOwned && !activeDrawer) document.body.classList.remove('overflow-hidden');
      state.bodyOwned = false;
      const focus = state.previousFocus;
      state.previousFocus = null;
      if (restoreFocus && focus && focus.isConnected !== false && typeof focus.focus === 'function') {
        if (activeDrawer && activeDrawer.contains && activeDrawer.contains(focus) && typeof win.trapFocus === 'function') win.trapFocus(activeDrawer.querySelector('.drawer__inner'), focus);
        else focus.focus();
      }
    }
    function setBusy(busy) {
      state.busy = busy;
      root.setAttribute('aria-busy', String(busy));
      const accept = node('accept');
      if (accept) {
        accept.disabled = busy || state.preview || !state.variant || !state.retryable || state.accepted;
        accept.textContent = busy ? labels().adding || 'Adding…' : state.accepted ? labels().added || 'Added' : state.retryable && state.active && state.active.failed ? labels().retry || 'Try again' : labels().add || 'Add to my order';
      }
      const select = node('variant');
      if (select) select.disabled = busy || state.preview && !state.variant || state.accepted || state.uncertain;
      text('status', busy ? labels().adding || '' : '');
    }
    function showError(message) {
      text('error', message || labels().error || 'This item could not be added. You can try again or continue to your cart.');
      hidden('error', false);
    }
    function updateVariant(id) {
      if (!state.active || state.busy || state.accepted || state.uncertain) return;
      state.variant = state.active.variants.find(function (variant) { return String(variant.id) === String(id); }) || null;
      state.retryable = true;
      state.active.failed = false;
      hidden('error', true);
      const variant = state.variant;
      const config = state.active.config;
      if (config.productTitle || config.title) text('title', config.productTitle || config.title);
      if (variant) {
        text('price', Number(variant.price) === 0 ? labels().free || 'FREE' : variant.priceMoney);
        const price = node('price');
        if (price && price.classList) price.classList.toggle('tbc-price--free', Number(variant.price) === 0);
        text('compare', variant.compareMoney || variant.compareAtPriceMoney);
        hidden('compare', !(Number(variant.compareAtPrice) > Number(variant.price)));
        const savingsLabel = labels().savings || 'Save {{ amount }}';
        text('savings', savingsLabel.replace(/\{\{\s*amount\s*\}\}/g, function () { return variant.savingsMoney || ''; }));
        hidden('savings', !(Number(variant.compareAtPrice) > Number(variant.price)) || !variant.savingsMoney);
        const select = node('variant');
        if (select) select.value = String(variant.id);
      } else {
        text('price', labels().pricePlaceholder || '');
        const price = node('price');
        if (price && price.classList) price.classList.toggle('tbc-price--free', false);
        hidden('compare', true);
        hidden('savings', true);
      }
      function imageSource(value) { return typeof value === 'string' ? value : value && (value.url || value.src); }
      const override = imageSource(config.displayImage);
      const source = override || imageSource(variant && variant.image);
      const image = node('image');
      if (image) {
        image.hidden = !source;
        if (source) {
          image.src = source;
          image.alt = (override ? config.displayImageAlt : variant && variant.imageAlt) || config.productTitle || config.title || '';
        }
      }
      hidden('image-placeholder', Boolean(source));
      setBusy(false);
    }
    function reveal() {
      root.hidden = false;
      root.inert = false;
      root.removeAttribute('inert');
      root.setAttribute('aria-hidden', 'false');
      root.dataset.tbcOfferOpen = 'true';
      lockBackground();
      focusFirst();
    }
    function conceal(restoreFocus) {
      root.hidden = true;
      root.inert = true;
      root.setAttribute('inert', '');
      root.setAttribute('aria-hidden', 'true');
      delete root.dataset.tbcOfferOpen;
      unlockBackground(restoreFocus);
    }
    function finish() {
      if (!state.active || state.active.finishing) return state.active && state.active.promise;
      const active = state.active;
      active.finishing = true;
      state.generation += 1;
      conceal(state.preview);
      if (state.preview) {
        state.active = null;
        active.resolve(true);
        return active.promise;
      }
      Promise.resolve().then(function () { return typeof active.context.continueToCart === 'function' ? active.context.continueToCart() : false; }).then(function (result) {
        if (state.active === active) state.active = null;
        active.resolve(result !== false);
      }, function () {
        if (state.active === active) state.active = null;
        active.resolve(false);
      });
      return active.promise;
    }
    async function accept() {
      if (!state.active || state.active.finishing || state.busy || state.preview || !state.variant || !state.retryable || state.accepted) return;
      const active = state.active;
      const generation = state.generation;
      const id = String(state.variant.id);
      setBusy(true);
      hidden('error', true);
      try {
        const result = await active.context.addVariant(id);
        if (generation !== state.generation || state.active !== active || state.disposed || root.isConnected === false) return;
        if (!result || result.ok !== true) {
          active.failed = true;
          state.uncertain = !result || Boolean(result.uncertain);
          state.retryable = Boolean(result && result.retryable !== false);
          showError(result && result.message);
          return;
        }
        state.accepted = true;
        finish();
      } catch (error) {
        if (generation !== state.generation || state.active !== active || state.disposed || root.isConnected === false) return;
        active.failed = true;
        state.uncertain = true;
        state.retryable = error && error.retryable === true;
        showError(labels().error);
      } finally {
        if (state.active === active && !active.finishing) setBusy(false);
      }
    }
    function show(context, preview) {
      if (state.active) return state.active.promise;
      const config = context && context.config || configFromMarkup();
      const variants = eligibleVariants(preview ? Object.assign({}, config, { enabled: true }) : config);
      if (state.disposed || root.isConnected === false || config.template !== 'danielmogs2' || preview && config.designMode !== true) return Promise.resolve(false);
      if (!preview && (!variants.length || !context || typeof context.addVariant !== 'function')) {
        return Promise.resolve().then(function () { return context && typeof context.continueToCart === 'function' ? context.continueToCart() : false; }).then(function (result) { return result !== false; });
      }
      const active = { context: context || {}, config: config, variants: variants, failed: false, finishing: false };
      active.promise = new Promise(function (resolve) { active.resolve = resolve; });
      state.active = active;
      state.generation += 1;
      state.preview = Boolean(preview);
      state.accepted = false;
      state.uncertain = false;
      state.retryable = true;
      state.busy = false;
      text('heading', config.heading);
      text('intro', config.intro);
      hidden('intro', !config.intro);
      const select = node('variant');
      if (select && document.createElement) {
        select.textContent = '';
        variants.forEach(function (variant) {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title || config.productTitle || config.title;
          select.appendChild(option);
        });
        select.hidden = variants.length <= 1;
        hidden('variant-field', variants.length <= 1);
      }
      const initial = variants.find(function (variant) { return String(variant.id) === String(config.variantId); }) || variants[0];
      updateVariant(initial && initial.id);
      reveal();
      return active.promise;
    }
    function onClick(event) {
      if (!state.active || state.active.finishing) return;
      const target = event.target;
      function matches(name) { return target && target.closest && target.closest('[data-tbc-offer-' + name + ']'); }
      if (matches('accept')) { event.preventDefault(); accept(); }
      else if (matches('close') || matches('continue') || target === node('backdrop')) { event.preventDefault(); finish(); }
    }
    function onChange(event) { if (event.target === node('variant')) updateVariant(event.target.value); }
    function onKeydown(event) {
      if (!state.active || state.active.finishing) return;
      if (event.key === 'Escape' || event.code === 'Escape') { state.escapeGesture = true; event.preventDefault(); event.stopPropagation(); return; }
      if (event.key !== 'Tab') return;
      const list = focusables();
      const first = list[0], last = list[list.length - 1];
      if (!first) { event.preventDefault(); focusFirst(); return; }
      const focused = document.activeElement;
      if (event.shiftKey && (focused === first || !root.contains(focused))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (focused === last || !root.contains(focused))) { event.preventDefault(); first.focus(); }
    }
    function onKeyup(event) {
      if (event.key !== 'Escape' && event.code !== 'Escape') return;
      if (!state.escapeGesture && (!state.active || state.active.finishing)) return;
      state.escapeGesture = false;
      event.preventDefault();
      event.stopPropagation();
      if (state.active && !state.active.finishing) finish();
    }
    function dispose() {
      if (state.disposed) return;
      state.disposed = true;
      state.generation += 1;
      if (state.active) {
        const active = state.active;
        conceal(true);
        state.active = null;
        active.resolve(false);
      }
      root.removeEventListener('click', onClick);
      root.removeEventListener('change', onChange);
      document.removeEventListener('keydown', onKeydown, true);
      document.removeEventListener('keyup', onKeyup, true);
    }
    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('keyup', onKeyup, true);
    return { show: show, accept: accept, finish: finish, dispose: dispose, state: state, updateVariant: updateVariant, onKeydown: onKeydown, onKeyup: onKeyup };
  }

  function install(win) {
    if (win.TBCPostAddOffer && win.TBCPostAddOffer.version === VERSION) return win.TBCPostAddOffer;
    if (win.TBCPostAddOffer && typeof win.TBCPostAddOffer.dispose === 'function') win.TBCPostAddOffer.dispose();
    const controllers = new Map();
    let observer = null;
    let disposed = false;
    function scan() {
      if (disposed) return;
      controllers.forEach(function (controller, root) { if (root.isConnected === false) { controller.dispose(); controllers.delete(root); } });
      win.document.querySelectorAll(ROOT).forEach(function (root) { if (!controllers.has(root)) controllers.set(root, createController(root, win)); });
    }
    function show(context) {
      if (disposed) return Promise.resolve(false);
      scan();
      const root = Array.from(controllers.keys()).find(function (element) { return element.isConnected !== false; });
      if (root) return controllers.get(root).show(context, false);
      return Promise.resolve().then(function () { return context && typeof context.continueToCart === 'function' ? context.continueToCart() : false; });
    }
    function preview(event) {
      if (disposed) return;
      const trigger = event.target.closest && event.target.closest('[data-tbc-offer-preview]');
      if (!trigger) return;
      scan();
      const root = Array.from(controllers.keys()).find(function (element) { return !trigger.dataset.tbcOfferSection || element.dataset.tbcOfferSection === trigger.dataset.tbcOfferSection; });
      if (root) {
        event.preventDefault();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        controllers.get(root).show({}, true);
      }
    }
    win.document.addEventListener('click', preview, true);
    scan();
    if (typeof win.MutationObserver === 'function') {
      observer = new win.MutationObserver(scan);
      observer.observe(win.document.body, { childList: true, subtree: true });
    }
    const api = { version: VERSION, show: show, dispose: function () {
      if (disposed) return;
      disposed = true;
      if (observer) observer.disconnect();
      win.document.removeEventListener('click', preview, true);
      controllers.forEach(function (controller) { controller.dispose(); });
      controllers.clear();
      if (win.TBCPostAddOffer === api) delete win.TBCPostAddOffer;
    } };
    win.TBCPostAddOffer = api;
    return api;
  }

  if (typeof window !== 'undefined' && window.document) install(window);
  else if (typeof module !== 'undefined' && module.exports) module.exports = { eligibleVariants: eligibleVariants, createController: createController, install: install };
}());
